import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
import './scroll'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)

let mm = gsap.matchMedia()
const bseWidget = document.querySelector('.engine-widget-wrapper')

function animateBseWidget() {
  gsap.to(bseWidget, {
    // mix y and yPercent to throw out widget from header primary
    y: 80,
    yPercent: 100,
    opacity: 0,
    duration: 3,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: bseWidget,
      start: 'top 15%',
      end: 'bottom 0%',
      scrub: 1,
    },
  })
}

function entryCorner(element) {
  gsap.fromTo(
    element,
    {
      scale: 0,
      opacity: 0,
    },
    {
      opacity: 1,
      scale: 1,
      duration: 1.2,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: element,
        start: 'top 65%',
      },
    }
  )
}

function expandPhoto(element) {
  gsap.fromTo(
    element,
    {
      scale: 1,
      opacity: 0,
    },
    {
      opacity: 1,
      scaleX: 1.2,
      duration: 1.2,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: element,
        start: 'top 65%',
        scrub: 1,
      },
    }
  )
}

function parallaxImage(element) {
  if (!element) return
  const triggerEl = element.parentElement || element
  gsap.to(element, {
    yPercent: -10,
    ease: 'none',
    scrollTrigger: {
      trigger: triggerEl,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
    },
  })
}

const entryCornerElements = document.querySelectorAll('.entry-corner')
if (entryCornerElements.length > 0) {
  entryCornerElements.forEach((element) => {
    entryCorner(element)
  })
}

mm.add('(min-width: 1024px)', () => {
  if (window.location.pathname !== '/' && bseWidget) {
    animateBseWidget()
  }
  expandPhoto(document.querySelector('.expand-photo'))
  const parallaxEls = document.querySelectorAll('.js-parallax')
  if (parallaxEls.length) {
    parallaxEls.forEach((el) => parallaxImage(el))
  }
})
